import React, { useState, useEffect } from "react";
import { FaFacebookF, FaXTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import "../css/Footer.css";


const Footer = () => {
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();

  
  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  return (
    <footer className="footer">
      <div className="footer-top">
        {/* Multi-column links section */}
        <div className="footer-links">
          <div className="footer-column">
            <h4>BidZone</h4>
            <ul>
              <li><a href={`/${setlang}/about`}>{setlang === "en" ? 'About Us':'درباره ما'}</a></li>
              <li><a href={`/${setlang}/careers`}>{setlang === "en" ? 'Career':'کار با ما'}</a></li>
              <li><a href={`/${setlang}/Community`}>{setlang === "en" ? 'Community':'فضای گفتگو'}</a></li>
            </ul>
          </div>
          <div className="footer-column">
            {setlang === "en" ? <h4>Platform</h4>:<h4>بازارگاه</h4>}
            <ul>
              <li><a href={`/${setlang}/services`}>{setlang === "en" ? 'Services' :' خدمات ما'}</a></li>
            </ul>
          </div>
          <div className="footer-column">
            {setlang === "en" ? <h4>Support</h4>:<h4>پشتیبانی</h4>}
            <ul>
              <li><a href={`/${setlang}/help`}> {setlang === "en" ? 'FAQ' : 'راهنما'} </a></li>
              <li><a href={`/${setlang}/our-terms-and-conditions`}> {setlang === "en" ? 'T&C' : 'شرایط و ضوابط'} </a></li>
              <li><a href={`/${setlang}/our-privacy-policy`}> {setlang === "en" ? 'Privacy Policy' : 'محرمانگی اطلاعات' } </a></li>
              <li><a href={`/${setlang}/our-return-policy`}> {setlang === "en" ? 'Return Policy' : 'بازگشت و استرداد' } </a></li>
            </ul>
          </div>
        </div>

        {/* Contact section */}
          <div className="footer-column">
            {setlang === "en" ? <h4>Contact Us</h4>:<h4>تماس</h4>}
            <ul>
              <li><a href={`/${setlang}/contact`}>{setlang === "en" ? 'Contact Support' : 'تماس با ما' }</a></li>
              <li><a>support@bidzone.ir</a></li>
            </ul>
          </div>

        {/* Social & external links */}
        <div className="footer-social">
          {setlang === "en" ? <h4>Follow Us</h4> : <h4>همراهی با ما</h4> }
          <div className="social-icons">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaXTwitter />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
          </div>

        </div>
      </div>

      {/* Bottom copyright */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} BidZone. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;